<div class="timeline pt-2 mt-2">
    <div class="row">
        <div class="col-md-2">
            <h6 *ngIf="userType === 'Beneficiary'"> <span class="pi pi-sitemap "></span> Timeline </h6>
        </div>
        <div class="col-md-10">
            <div class="ml-auto pb-3 pull-right">
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend completed"></div>
                    <div class="float-left"><span>Completed</span></div>
                </div>
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend submitted"></div>
                    <div class="float-left"><span>Submitted</span></div>
                </div>
                <div class="mr-3 float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend inprogress"></div>
                    <div class="float-left"><span>In-Progress</span></div>
                </div>
                <div class="float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend news"></div>
                    <div class="float-left"><span>New</span></div>
                </div>
                <div class="float-left d-flex align-items-center">
                    <div class="float-left mr-2 legend over-due"></div>
                    <div class="float-left"><span>Over Due</span></div>
                </div>
            </div>
        </div>
    </div>
    <div class="container" style="width: 70%;">
        <div class="row timeline-row">
            <div class="col justify-content-center col-styled col-bene">
                <span class="time-title">
                    Beneficiary Actions
                </span>
            </div>
            <div class="col justify-content-center col-styled col-att">
                <span class="time-title">
                    Petitioner / Lawfirm Actions
                </span>
            </div>
        </div>
    </div>
    <div class="container timeline-action">
        <div class="row timeline-row">
            <div class="col justify-content-center"></div>
            <div class="col justify-content-center">
                <hr class="separator timeline-separator">
            </div>
            <div class="col justify-content-center"></div>
        </div>
    </div>
    <p-timeline [value]="stepList">
        <ng-template pTemplate="marker" let-step>
            <span class="custom-marker" (mouseenter)="mouseEnter(step?.completionStatus)">
                <span [ngbTooltip]="step?.estimatedTime" [tooltipClass]="toolTipCustomClass" [ngClass]="{'complete-icon':step?.stepStatusDetails?.stepStatusCode==='COMPLETE',
                    'inprogress-icon': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 
                    'new-icon':step?.stepStatusDetails?.stepStatusCode === 'NEW' || step.isCustomStep, 
                    'submit-icon':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT',
                    'overDue-icon': step?.completionStatus === 'OVERDUE' }"></span>
            </span>
        </ng-template>
        <ng-template pTemplate="content" let-step>
            <!-- Lawfirm / Petitioner Side -->
            <div class="d-inline-flex" *ngIf="step.isPetitionerAction===1 || step.isAttorneyAction===1">
                <hr class="separator">
                 <!-- IM-20492 bcz of this story comments lock  -->
                <!-- <span class="pet-lock-unlock" *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
                    <div class="icon-lock-background locks task-notes-btn"
                        [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
                        #btnNote (click)="lockpanel.toggle($event, btnNote)">
                        <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span> <span
                            *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
                    </div>
                    <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel-pet" [showCloseIcon]="true"
                        [dismissable]="true">
                        <ng-template pTemplate>
                            <lock-unlock-steps-library [step]="step"
                                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
                        </ng-template>
                    </p-overlayPanel>
                    <hr class="pet-separator">
                </span> -->
                <div class=" p-shadow-2"
                    [ngClass]="{'completed-border':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'new-border-custom': step?.isCustomStep}">
                    <button
                    *ngIf="!step.isCustom" [disabled]="userType === 'Beneficiary'" 
                        [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW' || step?.isCustomStep, 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT'}"
                        (click)="(step?.isPetitionerEditable === 1 || step?.isAttorneyEditable === 1) && handleStepClick(step)"
                        [class.lock]="step?.isAttorneyEditable === 0 && step?.isPetitionerEditable === 0">
                        {{ step.stepName == 'Print I-140 Petition' ? 'Send for Signature & Generate Final' : step.stepName }}
                    </button>

                        <button *ngIf="step.isCustom"
                        (click)="handleStepClick(step)">
                        {{ step.stepName }}</button>
                </div>
                <!-- Step Notes -->
                <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
                    <div class="icon-background notes task-notes-btn" [pTooltip]="step?.notes?.noteText"
                        [class.yellow]="step?.notesAvailable===true" #btnNote
                        (click)="notepanel.toggle($event, btnNote)">
                        <span class="icn-note"></span>
                    </div>
                    <p-overlayPanel #notepanel appendTo="btnNote" class="notepanel" [showCloseIcon]="true"
                        [dismissable]="true">
                        <ng-template pTemplate>
                            <task-notes-lib [step]="step" (noteAdded)="updateNoteAvailability($event, step)">
                            </task-notes-lib>
                        </ng-template>
                    </p-overlayPanel>
                </span>
                <!-- End -->
            </div>
        </ng-template>
        <ng-template pTemplate="opposite" let-step>
            <!-- Beneficiary Side -->
            <div class="d-inline-flex" *ngIf="step.isBeneficiaryAction===1">
                <!-- Step Lock /Unlock -->
                <span *ngIf="userType === 'Petitioner' || userType === 'Attorney'">
                    <div class="icon-lock-background locks task-notes-btn"
                        [pTooltip]="step?.isBeneficiaryVisible === 0 ? 'Step Locked For Beneficiary' : 'Lock Step For Beneficiary'"
                        #btnNote (click)="lockpanel.toggle($event, btnNote)">
                        <span *ngIf="step?.isBeneficiaryVisible === 0" class="icn-lock"></span>
                        <span *ngIf="step?.isBeneficiaryVisible === 1" class="icn-unlock"></span>
                    </div>
                    <p-overlayPanel #lockpanel appendTo="btnNote" class="lockpanel" [showCloseIcon]="true"
                        [dismissable]="true">
                        <ng-template pTemplate>
                            <lock-unlock-steps-library [step]="step"
                                (lockUnlock)="updateLockUnlock($event, step)"></lock-unlock-steps-library>
                        </ng-template>
                    </p-overlayPanel>
                </span>
                <!-- End -->
                <div class="p-shadow-2"
                    [ngClass]="{'completed-border-ben':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress-border-ben': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new-border-ben':step?.stepStatusDetails?.stepStatusCode === 'NEW', 'submit-border-ben':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT', 'new-border-custom': step?.isCustomStep}">
                    <button [disabled]="userType === 'Petitioner' || userType === 'Attorney'"
                        [ngClass]="{'complete':step?.stepStatusDetails?.stepStatusCode==='COMPLETE','inprogress': step?.stepStatusDetails?.stepStatusCode === 'INPROGRESS', 'new':step?.stepStatusDetails?.stepStatusCode === 'NEW' || step?.isCustomStep, 'submit':step?.stepStatusDetails?.stepStatusCode === 'SUBMIT'}"
                        (click)="step?.isBeneficiaryEditable === 1 &&handleStepClick(step)"
                        [class.lock]="step?.isBeneficiaryVisible === 0">
                        {{ step.stepName == 'Print I-140 Petition' ? 'Send for Signature & Generate Final' : step.stepName }}</button>
                </div>
                <hr class="separator">
            </div>
        </ng-template>
    </p-timeline>
</div>